import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import {
  Typography,
  TypographyProps,
  Link,
  LinkProps,
  Card,
  Grid,
  Box,
  BoxProps,
  Button,
  ButtonProps,
  Accordion,
  AccordionSummary,
  AccordionSummaryProps,
  AccordionDetails,
  AccordionDetailsProps,
} from '@mui/material';

import { DataGrid, DataGridProps } from '@mui/x-data-grid';
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';
import { metricCardEnum } from 'app/components/StyledComponents/type';

export const ComponentPageContainer = styled('div')(({ theme }) => ({
  borderTopLeftRadius: '15px',
  transition: 'ease-in',
  transitionDelay: '100ms',
  background: 'white',
  height: 'inherit',
  paddingTop: '64px',
  //   position: 'fixed',
  //   width: '-moz-available' /* For Mozzila */,
  //   width: '-webkit-fill-available' /* For Chrome */,
  //   width: 'stretch ',
}));

export const PageContainer = styled('div')(({ theme }) => ({
  padding: '40px',
}));

export const PageHeader = styled(Typography)<TypographyProps>(({ theme }) => ({
  variant: 'h4',
  component: 'div',
  display: 'flex',
  alignItems: 'center',
  height: '32px',
  fontSize: '24px',
  fontWeight: 600,
  marginBottom: '48px',
}));

export const BreadcrumbContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  ':visited': 'black',
  // marginBottom: '0px',
  height: '24px',
  fontSize: '16px',
  alignItems: 'center',
}));

export const BreadcrumbLinkComponent = styled(Link)<LinkProps>(({ theme }) => ({
  ':visited': 'black',
  color: 'text.primary',
  height: '24px',
  fontSize: '16px',
  alignItems: 'center',
}));

export const DataTableContainer = styled(Box)<BoxProps>(({ theme }) => ({
  height: 1186,
  width: '100%',
}));

export const DataTableHeaderActions = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: '8px',
  alignItems: 'center',
  height: '24px',
}));

export const DataGridStyledComponent = styled(DataGrid)<DataGridProps>(
  ({ theme, onRowClick }) => ({
    '& .super-app-theme--New': {
      backgroundColor: '#E8E8E8',
      '&:hover': {
        backgroundColor: '#F5F5F5!important',
      },
    },
    // '& .MuiDataGrid-row:hover': {
    //   cursor: onRowClick ? 'pointer' : '',
    // },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#0f284c',
      color: '#fff',
    },
    '& .MuiDataGrid-columnHeader .MuiCheckbox-root svg': {
      color: 'white',
    },
    '& .MuiDataGrid-iconSeparator': {
      display: 'none',
    },

    // Keep the menu icon (three dots) always visible
    '& .MuiDataGrid-menuIconButton': {
      color: 'white', // Change the icon color to white
    },
    // Change the sort icon color to white
    '& .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-sortIcon': {
      color: 'white',
    },
  }),
);

export const MetricCardStyledComponent = styled(Box)<any>(
  ({ theme, cardSelection }) => ({
    flexShrink: 0,
    borderRadius: '5px',
    boxShadow: '0px 12px 34px -10px rgba(58, 77, 233, 0.15)',
    textAlign: 'center',
    background:
      cardSelection === metricCardEnum.topCard
        ? `linear-gradient(to bottom, ${theme.palette.secondary.main} 50%, white 50%)`
        : cardSelection === metricCardEnum.bottomCard
        ? `linear-gradient(to top, ${theme.palette.secondary.main} 50%, white 50%)`
        : '',
  }),
);

export const MetricGridContainerStyledComponent = styled(Grid)<any>(
  ({ theme, showPointer, active }: {theme: any; showPointer: boolean; active: boolean}) => ({
    cursor: showPointer ? 'pointer' : 'default',
    transition: 'all 0.3s ease', // Smooth transition
    padding: '24px',
    borderRadius: '10px',
    // height: '150px',
    boxShadow: '0px 5px 24px -10px rgb(73 91 255 / 27%)',

    backgroundColor: `${active && showPointer ? '#0D2748' : '#fff'}`,
    '&:hover': showPointer && !active
      ? {
          // backgroundColor: '#e5e8eb',
          boxShadow: '0px 5px 40px -10px rgb(73 91 255 / 35%)',
          transform: 'scale(1.03)'
        }
      : {},
  })
);

export const MetricGraphBoxContainerStyledComponent = styled(Box)<any>(
  ({ theme, hasData }) => ({
    height: '100%',
    width: '100%',
    opacity: hasData ? 1 : 0.3,
  }),
);

export const MetricGridStyledComponent = styled(Grid)<any>(
  ({ theme, isSelected }) => ({
    color: isSelected ? 'white' : 'black',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    
  }),
);

export const MetricBoxContainerStyledComponent = styled(Box)<any>(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
  }),
);

export const MetricCountTypograpgyStyledComponent = styled(Typography)<any>(
  ({ theme }) => ({
    fontWeight: 'bold',

    lineHeight: 1,
  }),
);

export const MetricLabelTypograpgyStyledComponent = styled(Typography)<any>(
  ({ theme }) => ({
    lineHeight: 1.1,
    mb: 2,
    // whiteSpace: 'nowrap',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    textAlign: 'center',
    textWrap: 'nowrap',
  }),
);

export const OutlinedButtonStyledComponent = styled(Button)<any>(
  ({ theme }) => ({
    minWidth: '145px',
    padding: '12px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    borderColor: '#d1d5db',
    color: '#6b7280',
    backgroundColor: 'transparent',
    border: '1px solid #d1d5db',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f3f4f6',
      borderColor: '#9ca3af',
      color: '#374151',
    },
    '&.Mui-selected': {
      backgroundColor: '#374151',
      borderColor: '#374151',
      color: 'white',
      '&:hover': {
        backgroundColor: '#1f2937',
        borderColor: '#1f2937',
      },
    },
  }),
);

export const NurturingHistoryRootComponent = styled(Box)<BoxProps>(
  ({ theme }) => ({
    background: '#f3f4f6',
    padding: '8px 0',
  }),
);

export const NurturingHistoryContainerComponent = styled(Box)<BoxProps>(
  ({ theme }) => ({
    width: '800px',
    height: 'auto',
    background: 'transparent',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '32px',
    borderRadius: '0.5rem',
    boxShadow: 'none',
  }),
);

export const NurturingHistoryInnerContainerComponent = styled(Box)<BoxProps>(
  ({ theme }) => ({
    background: '#f3f4f6',
    padding: '32px 16px',
  }),
);

export const NurturingHistoryAccordionComponent = styled(Accordion)<any>(
  ({ theme, index, messagesLength }) => ({
    marginBottom: 0,
    background: 'transparent',
    width: '100%',
    borderRadius: '12px',
    border: 'none',
    boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    transition: 'all 0.2s ease',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: '#f3f4f6',
      cursor: 'pointer',
      boxShadow: 'none',
      borderColor: 'transparent',
    },
    '&.Mui-expanded': {
      backgroundColor: '#ffffff',
      borderColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#ffffff',
        borderColor: 'transparent',
      },
    },
    '&:before': {
      display: 'none',
    },
  }),
);

export const NurturingHistoryAccordionSummaryComponent = styled(
  AccordionSummary,
)<AccordionSummaryProps>(({ theme }) => ({
  height: '100%',
  width: '100%',
  justifyContent: 'start',
  alignItems: 'start',
  margin: 0,
  padding: 0,
  borderRadius: '12px',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
  },
  '&.Mui-expanded': {
    backgroundColor: 'transparent',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
}));

export const NurturingHistoryAccordionDetailsComponent = styled(
  AccordionDetails,
)<AccordionDetailsProps>(({ theme }) => ({
  margin: 0,
  padding: 0,
  backgroundColor: 'transparent',
}));

export const NurturingEventDatesContainerComponent = styled(Box)<any>(
  ({ theme, showContainer }) => ({
    display: showContainer ? 'flex' : 'none',
    marginTop: '24px',
    background: 'transparent',
    width: '100%',
    padding: '8px',
    boxShadow: 'none',
  }),
);

export const EventDateContainerComponent = styled(Typography)<any>(
  ({ theme, showContainer }) => ({
    marginRight: '32px',
    fontSize: '16px',
    flex: 1,
    fontWeight: 600,
    display: showContainer ? '' : 'none',
  }),
);

export const EventDateComponent = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    fontSize: '16px',
    color: '#6b7280',
  }),
);

export const AccordionComponent = styled(Accordion)<any>(
  ({ theme, index, messagesLength }) => ({
    width: '100%',
    border: '1px solid',
    borderColor: 'rgb(0,0,0,0.2)',
    borderRadius: '5px',
  }),
);

export const AccordionSummaryComponent = styled(
  AccordionSummary,
)<AccordionSummaryProps>(({ theme }) => ({
  height: '100%',
  width: '100%',
  justifyContent: 'start',
  alignItems: 'start',
  margin: 0,
  padding: 0,
  // '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
  //   transform: 'rotate(90deg)', // Points down when expanded
  // },
}));

export const AccordionDetailsComponent = styled(
  AccordionDetails,
)<AccordionDetailsProps>(({ theme }) => ({
  margin: 0,
  padding: 0,
}));

export const UploadButtonStyledComponent = styled(Button)<ButtonProps>(
  ({ theme }) => ({
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    padding: '5px 10px',
    textTransform: 'uppercase',
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  })
);
